<header class="em-c-header--blue">
  <nav class="first-header">
    <ul>
      <li>
        @if (username) {
          <div class="user-name">
            <span>
              Welcome,&nbsp;
            </span>
            <div>
              <span>
                {{username}}
              </span>
              <span>
                {{modifiedRoleName}}
              </span>
            </div>
          </div>
        }
      </li>
      <li>
        <a routerLink="/login" (click)="Logout()" (keyup.enter)="Logout()" tabindex="0" role="button">Sign out</a>
      </li>
    </ul>
  </nav>
  <nav class="second-header">
    <div class="col-1">
      <h2 class="font-light">
        PVT Lab
        @if (experimentName) {
          <span class="font-20">- {{experimentName}}</span>
        }
      </h2>
      <!-- <h4 class="font-light">EM Labs PVT sample management tracker</h4> -->
      @if (experimentName) {
        <h4 class="font-light cursor-pointer" (click)="GetBackToSampleList()" (keyup.enter)="GetBackToSampleList()" tabindex="0">
          Sample overview
        </h4>
      }
      @if (projectNumber) {
        <h4 class="font-light cursor-pointer" (click)="GoBackToProjectDetails()" (keyup.enter)="GoBackToProjectDetails()" tabindex="0">
          {{projectNumber}}
        </h4>
      }
    </div>
    <div class="col-1">
      <div class="user-details">
        <p>
          <a routerLink="/projectlist">
            Project overview
          </a>
        </p>
      </div>
    </div>
  </nav>
</header>

